module.exports = __webpack_public_path__ + "img/OHM_MIDDLE_MARKET.e58ed3e7.png";